// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legal_basis-module__container--9DFKA{border:1px solid #c6ced5;background-color:#fff;border-radius:4px;box-shadow:0 2px 4px #c6ced5;margin-bottom:40px}.legal_basis-module__header--kUNe9{font-weight:500;font-size:16px;line-height:24px;letter-spacing:0px;text-align:left;padding:24px}.legal_basis-module__title--3bydQ{margin-top:8px;color:#616161;font-weight:400;font-size:12px;line-height:18px;letter-spacing:0}.legal_basis-module__legislation--3jqT2{border-top:1px solid #c6ced5;padding:24px}.legal_basis-module__footer--3m7O5{border-top:1px solid #c6ced5;padding:24px}\n", ""]);
// Exports
exports.locals = {
	"container": "legal_basis-module__container--9DFKA",
	"header": "legal_basis-module__header--kUNe9",
	"title": "legal_basis-module__title--3bydQ",
	"legislation": "legal_basis-module__legislation--3jqT2",
	"footer": "legal_basis-module__footer--3m7O5"
};
module.exports = exports;
